import NotificationsContent from './components/NotificationsContent'
import SubscriptionsContent from './components/SubscriptionsContent'

const Notifications = () => {
  return (
    <>
      <div className='m-0 w-100 fs-2hx fw-semibold mb-3'>Notifications</div>
      <p className='fs-5 fw-semibold text-gray-800'>
        View all notifications and configure your notificaiton subscriptions.
      </p>

      <div className='mt-10'>
        <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6'>
          <li className='nav-item'>
            <a
              className='nav-link fs-4 fw-bold text-gray-700 active'
              data-bs-toggle='tab'
              href='#kt_tab_pane_1'
            >
              Notifications
            </a>
          </li>
          <li className='nav-item'>
            <a
              className='nav-link fs-4 fw-bold text-gray-700'
              data-bs-toggle='tab'
              href='#kt_tab_pane_2'
            >
              Subscriptions
            </a>
          </li>
        </ul>
        <div className='tab-content' id='myTabContent'>
          <div className='tab-pane fade show active' id='kt_tab_pane_1' role='tabpanel'>
            <NotificationsContent />
          </div>
          <div className='tab-pane fade' id='kt_tab_pane_2' role='tabpanel'>
            <SubscriptionsContent />
          </div>
        </div>
      </div>
    </>
  )
}

export default Notifications
